import Moment from 'moment';
import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {event} from '../../../utilities/withAnalytics';
import classnames from 'classnames';

import './PersonasViewer.scss';


// Note personas should be sorted by most recently updated
export default class PersonasViewer extends Component {
  onSelectPersona = () => {
    event({
      category: 'Select Persona',
      action: 'Click',
    });
  }

  render(){
    const {personaList, activeId} = this.props;
    let personaListItems = personaList.map(
      (
        {
          age,
          education,
          id,
          key,
          marital_status,
          name,
          occupation,
          persona_image,
          residence,
          theme,
          updated_at,
        }, i)=>{
          const itemClasses = classnames([
            'personas-item-container',
            {
              'active': id === activeId
            }
          ]);
          // TODO: Create individual item component
          return(
            <Link
              key={id}
              className={itemClasses}
              to={`/${id}/${key?key:''}`}
              onClick={this.onSelectPersona}
            >
              <div className="item-user">
                <div
                  className="item-user-img-container"
                  style={{backgroundImage: "url(" + persona_image + ")" }}
                />
                <div className="item-user-info">
                  <div>{name}</div>
                  <div>{age}</div>
                  <div>{residence}</div>
                  <div>{education}</div>
                  <div>{occupation}</div>
                  <div>{marital_status}</div>
                </div>
              </div>
              <div className="item-meta">
                <div className="item-meta-info">
                  <time dateTime={updated_at}>{Moment(updated_at).format('MMM DD, HH:mma')}</time>
                  <div className="meta-info-access">{key && 'Edit and '}View Access</div>
                </div>
                <div className={"item-color-theme " + theme}>
                </div>
              </div>
            </Link>
          );
    });
    return (
      <div className="personas-container">
        {personaListItems}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/pages/persona/sidebar/PersonasViewer.jsx